export default (value: any, defaultText: string = "N/A") => {
    if(value === null || value === undefined) {
        return defaultText;
    }

    return value;
}